import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// En desarrollo: ayuda a diagnosticar si faltan variables
if (process.env.NODE_ENV === 'development' && (!supabaseUrl || !supabaseAnonKey)) {
  console.warn(
    '[Supabase] Variables faltantes:',
    !supabaseUrl ? 'REACT_APP_SUPABASE_URL' : '',
    !supabaseAnonKey ? 'REACT_APP_SUPABASE_ANON_KEY' : '',
    '- Revisa .env y reinicia npm start'
  );
}

let supabase = null;
if (supabaseUrl && supabaseAnonKey && supabaseUrl.length > 0) {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey);
  } catch (e) {
    console.error('Supabase init error:', e);
  }
}

export { supabase };
